import React from "react";
import {
  FaHeartbeat,
  FaBaby,
  FaRegCalendarCheck,
  FaShieldAlt,
  FaHandsHelping,
} from "react-icons/fa";
import { GiLotus } from "react-icons/gi";
import { motion } from "framer-motion";
import { FiHome } from "react-icons/fi";
import { Link } from "react-router-dom";

const tools = [
  {
    icon: <FaRegCalendarCheck className="text-pink-500 text-3xl" />,
    title: "Period Tracker",
  },
  {
    icon: <FaHeartbeat className="text-pink-500 text-3xl" />,
    title: "Pregnancy Probability Checker",
  },
  {
    icon: <GiLotus className="text-pink-500 text-3xl" />,
    title: "Safe Days Calculator",
  },
  {
    icon: <FaRegCalendarCheck className="text-pink-500 text-3xl" />,
    title: "Average Day Calculator",
  },
  {
    icon: <FaBaby className="text-pink-500 text-3xl" />,
    title: "Pregnancy Tracker",
  },
  {
    icon: <FaBaby className="text-pink-500 text-3xl" />,
    title: "Due Date Estimator",
  },
  {
    icon: <FaShieldAlt className="text-pink-500 text-3xl" />,
    title: "Pregnancy Safety & Awareness",
  },
  {
    icon: <FaHandsHelping className="text-pink-500 text-3xl" />,
    title: "Wellness & Nutrition Tips",
  },
];

const AboutUs = () => {
  return (
    <div className="bg-pink-50 font-nunito py-10 px-6 md:px-20 min-h-screen">
      {/* Back to Home Button */}
      <div className="flex justify-start  mb-6">
        <Link
          to="/"
          className="flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-md hover:bg-pink-50 transition-colors duration-200"
        >
          <FiHome className="text-pink-500" />
          <span className="text-purple-700 font-medium">Back to Home</span>
        </Link>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-6xl mx-auto text-center"
      >
        <h2 className="text-4xl font-cormorant font-bold text-pink-600 mb-4">
          About Us
        </h2>
        <p className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto">
          Welcome to{" "}
          <span className="font-semibold text-pink-500">FlowHearts.com</span> —
          a trusted space built to support you through every stage of womanhood.
          We’re here to make your health journey more informed, gentle, and
          empowering. 🌷
        </p>

        {/* Mission & Vision */}
        <div className="grid md:grid-cols-2 gap-10 mb-16 text-left">
          <div className="bg-white p-6 rounded-2xl shadow-md">
            <h2 className="text-2xl font-semibold text-pink-600 mb-2">
              Our Mission
            </h2>
            <p className="text-gray-600">
              To deliver meaningful and simple digital experiences that help
              women better understand and care for their bodies—every single
              day.
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-md">
            <h2 className="text-2xl font-semibold text-pink-600 mb-2">
              Our Vision
            </h2>
            <p className="text-gray-600">
              A world where every woman, regardless of age or background, has
              easy access to trusted information and beautiful tools that
              support her health decisions.
            </p>
          </div>
        </div>

        {/* Our Tools Section (Non-clickable) */}
        <h2 className="text-2xl font-bold text-pink-600 mb-6">What We Offer</h2>
        <p className="text-gray-600 mb-6 max-w-3xl mx-auto">
          Our platform includes a variety of tools to support your reproductive
          health, fitness, and well-being—all created with care, research, and
          love.
        </p>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-16">
          {tools.map((tool, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.03 }}
              className="bg-white rounded-2xl p-5 shadow-md flex flex-col items-center text-center"
            >
              {tool.icon}
              <span className="mt-3 font-medium text-gray-700">
                {tool.title}
              </span>
            </motion.div>
          ))}
        </div>

        {/* Trust Section */}
        <div className="bg-white p-8 rounded-2xl shadow-md max-w-4xl mx-auto">
          <h2 className="text-2xl font-semibold text-pink-600 mb-4">
            Why Women Trust Us
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2 text-left">
            <li>Tools designed for simplicity and empathy</li>
            <li>Accurate, research-based health algorithms</li>
            <li>Clean, safe, and private user experience</li>
            <li>Empowering every woman through every phase of life</li>
          </ul>
        </div>
      </motion.div>
    </div>
  );
};

export default AboutUs;
